import { useSettings, useUpdateSettings } from "../../hooks/useSettings";
import { DEFAULT_CLIENT_SETTINGS } from "@cmmd-forge/contracts/settings";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import {
  SettingResetButton,
  SettingsPageContainer,
  SettingsRow,
  SettingsSection,
} from "./settingsLayout";
import { searchableSetting } from "./settingsSearch";

export function AgentContextPanel() {
  return (
    <SettingsPageContainer>
      <AgentContextSection />
    </SettingsPageContainer>
  );
}

export function AgentContextSection() {
  const settings = useSettings();
  const { updateSettings } = useUpdateSettings();
  const ctx = settings.agentContext;
  const defaults = DEFAULT_CLIENT_SETTINGS.agentContext;

  return (
    <SettingsSection id="agent-context" title="Context">
      <SettingsRow
        {...searchableSetting("workflow-brain-context")}
        description="Automatically inject relevant Brain memories into every agent's context on spawn."
        resetAction={
          ctx.brainContextAlways !== defaults.brainContextAlways ? (
            <SettingResetButton
              label="brain context"
              onClick={() =>
                updateSettings({
                  agentContext: { ...ctx, brainContextAlways: defaults.brainContextAlways },
                })
              }
            />
          ) : null
        }
        control={
          <Switch
            checked={ctx.brainContextAlways}
            onCheckedChange={(checked) =>
              updateSettings({
                agentContext: { ...ctx, brainContextAlways: Boolean(checked) },
              })
            }
            aria-label="Always inject Brain context"
          />
        }
      />

      <SettingsRow
        {...searchableSetting("workflow-web-search")}
        description="Allow agents to search the web for up-to-date information during their tasks."
        resetAction={
          ctx.webSearchEnabled !== defaults.webSearchEnabled ? (
            <SettingResetButton
              label="web search"
              onClick={() =>
                updateSettings({
                  agentContext: { ...ctx, webSearchEnabled: defaults.webSearchEnabled },
                })
              }
            />
          ) : null
        }
        control={
          <Switch
            checked={ctx.webSearchEnabled}
            onCheckedChange={(checked) =>
              updateSettings({
                agentContext: { ...ctx, webSearchEnabled: Boolean(checked) },
              })
            }
            aria-label="Enable web search for agents"
          />
        }
      />

      <SettingsRow
        {...searchableSetting("workflow-brain-max-tokens")}
        description="Maximum number of tokens from Brain context injected per agent turn."
        resetAction={
          ctx.brainMaxTokens !== defaults.brainMaxTokens ? (
            <SettingResetButton
              label="brain max tokens"
              onClick={() =>
                updateSettings({
                  agentContext: { ...ctx, brainMaxTokens: defaults.brainMaxTokens },
                })
              }
            />
          ) : null
        }
        control={
          <Input
            type="number"
            className="w-24 text-right"
            min={100}
            max={16000}
            step={100}
            value={ctx.brainMaxTokens}
            onChange={(event) => {
              const parsed = Number.parseInt(event.target.value, 10);
              if (!Number.isNaN(parsed) && parsed >= 100 && parsed <= 16000) {
                updateSettings({ agentContext: { ...ctx, brainMaxTokens: parsed } });
              }
            }}
            aria-label="Brain max tokens"
          />
        }
      />

      <SettingsRow
        {...searchableSetting("workflow-web-max-results")}
        description="Maximum number of web search results returned per agent search call."
        resetAction={
          ctx.webMaxResults !== defaults.webMaxResults ? (
            <SettingResetButton
              label="web max results"
              onClick={() =>
                updateSettings({
                  agentContext: { ...ctx, webMaxResults: defaults.webMaxResults },
                })
              }
            />
          ) : null
        }
        control={
          <Input
            type="number"
            className="w-20 text-right"
            min={1}
            max={20}
            value={ctx.webMaxResults}
            onChange={(event) => {
              const parsed = Number.parseInt(event.target.value, 10);
              if (!Number.isNaN(parsed) && parsed >= 1 && parsed <= 20) {
                updateSettings({ agentContext: { ...ctx, webMaxResults: parsed } });
              }
            }}
            aria-label="Web max results"
          />
        }
      />
    </SettingsSection>
  );
}
